// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../primitives/I18n.res.js";
import * as Json from "../primitives/Json.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../core/Request.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../primitives/ReactUpdateDebounced.res.js";
import * as InputSearchComboBoxField from "../resources/selection-and-input/InputSearchComboBoxField.res.js";

function decodeItem(result) {
  let dict = Json.flatDecodeDictFieldDict(Json.decodeDict(result), "properties");
  let match = Json.flatDecodeDictFieldString(dict, "label");
  let match$1 = Json.flatDecodeDictFieldString(dict, "name");
  let match$2 = Stdlib_Option.getOr(Json.flatDecodeDictFieldString(dict, "postcode"), "");
  let match$3 = Stdlib_Option.getOr(Json.flatDecodeDictFieldString(dict, "city"), "");
  let match$4 = Stdlib_Option.getOr(Json.flatDecodeDictFieldString(dict, "country"), "France");
  if (match !== undefined && match$1 !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        label: match,
        name: match$1,
        postcode: match$2,
        city: match$3,
        country: match$4
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
}

function decode(result) {
  let decodedResult;
  try {
    decodedResult = Stdlib_Option.getExn(Stdlib_Option.map(Json.flatDecodeDictFieldArray(Json.decodeDict(result), "features"), arrayResult => arrayResult.map(address => Stdlib_Result.getExn(decodeItem(address), undefined))), undefined);
  } catch (exn) {
    return {
      TAG: "Error",
      _0: "MalformedResponse"
    };
  }
  return {
    TAG: "Ok",
    _0: decodedResult
  };
}

function make(query, param) {
  let endpoint = "https://api-adresse.data.gouv.fr/search?q=" + query;
  return Future.mapResult(Request.make(endpoint, "GET", undefined, false, true), undefined, decode);
}

let AddressListRequest = {
  decodeItem: decodeItem,
  decode: decode,
  make: make
};

function AddressComboBoxField(props) {
  let onRequestAutoComplete = props.onRequestAutoComplete;
  let value = props.addressName;
  let __required = props.required;
  let required = __required !== undefined ? __required : false;
  let match = React.useState(() => []);
  let setSearchResults = match[1];
  let searchResults = match[0];
  let match$1 = React.useState(() => false);
  let setLoading = match$1[1];
  let loading = ReactUpdateDebounced.use(match$1[0], 500);
  let shouldFetch = value.length >= 10;
  React.useEffect(() => {
    if (shouldFetch) {
      setLoading(param => true);
      let request = make(value, undefined);
      let future = Future.tapOk(request, searchResults => setSearchResults(param => searchResults));
      return () => Future.cancel(future);
    }
    setSearchResults(param => []);
  }, [value]);
  React.useEffect(() => {
    setLoading(param => false);
  }, [searchResults]);
  React.useEffect(() => {
    if (value === "") {
      onRequestAutoComplete({
        label: "",
        name: "",
        postcode: "",
        city: "",
        country: ""
      });
    }
  }, [value]);
  let items = searchResults.map(address => ({
    key: address.label,
    label: address.name + `, ` + address.postcode + ` ` + address.city,
    value: address
  }));
  let itemTextValue = React.useCallback(item => item.value.name, []);
  let onSelectItem = item => onRequestAutoComplete(item.value);
  let onSelectItem$1 = React.useCallback(onSelectItem, []);
  let showResults = ReactUpdateDebounced.use(shouldFetch, 350);
  return JsxRuntime.jsx(InputSearchComboBoxField.make, {
    label: I18n.t("Address"),
    required: required,
    loading: loading,
    placeholder: I18n.t("Entering an address"),
    errorMessage: props.errorMessage,
    sectionTitle: I18n.t("Suggested French addresses"),
    noResultLabel: I18n.t("No French address suggestion"),
    showResults: showResults,
    items: items,
    itemTextValue: itemTextValue,
    value: value,
    onInputChange: props.onInputChange,
    onSelectionChange: onSelectItem$1
  });
}

let queryValueThreshold = 10;

let make$1 = AddressComboBoxField;

export {
  AddressListRequest,
  queryValueThreshold,
  make$1 as make,
}
/* I18n Not a pure module */
